import React, { Component } from "react";

import ItemCard from "../../ListItem/ItemCard";
import no_image_img from "../../../no-image.png";
import ListScroll from "../../ListScroll/ListScroll";

import "./BestSellers.css";

class BestSellers extends Component {
    constructor(props) {
        super(props);
        this.no_image = { url: no_image_img };
    }

    indicators() {}

    render() {
        let items = this.props.bestSellers;
        return (
            <div className='BestSellersComponent'>
                <div className='caption'>
                    <a href='/search?sort=sold_count'>
                        پرفروش ترین ها
                        <a href='/search?sort=sold_count' className='all'>
                            (مشاهده همه)
                        </a>
                    </a>
                </div>
                <div className='BestSellersContainer'>
                    <ListScroll items={items} Component={ItemCard} key='id' />
                </div>
            </div>
        );
    }
}

export default BestSellers;
